import { render, staticRenderFns } from "./ListadoSede.vue?vue&type=template&id=2d27da24"
import script from "./ListadoSede.vue?vue&type=script&lang=js"
export * from "./ListadoSede.vue?vue&type=script&lang=js"
import style0 from "./ListadoSede.vue?vue&type=style&index=0&id=2d27da24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports